import { useIsMobile } from '@niaratech/niara-react-components/src';
import React, { useEffect, useState } from 'react';
import SwiperCore, { A11y, Controller, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import { SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import Gallery from '../../components/Gallery';
import ImageViewer from '../../components/ImageViewer';
import ModalOTA from '../../components/ModalOTA';
import { IcGallery } from '../../Icons';
import SlideShow from '../SlideShow';
import ImageMosaic, { type ImageMosaicProps } from './ImageMosaic/ImageMosaic';
import type { ShowButtonsProps } from './styles';
import * as S from './styles';
SwiperCore.use([Controller, Navigation, Pagination, Scrollbar, Thumbs, A11y]);
export type ImageGalleryProps = {
  dataGallery: string[];
  showGalleryBar?: boolean;
  onOpenGallery?: () => void;
  barNone?: boolean;
  recommendedBadge?: string;
  recommendedText?: string;
  style?: any;
  isImageMosaic?: boolean;
  imageMosaicSize?: ImageMosaicProps['size'];
  customMosaicHeight?: ImageMosaicProps['customHeight'];
  title?: string;
  borderRadius?: string;
  fetchOffset?: number;
} & ShowButtonsProps;
const ImageGallery: React.FC<ImageGalleryProps> = ({
  dataGallery = [],
  showGalleryBar = true,
  showButtons = 'both',
  barNone,
  recommendedBadge,
  recommendedText,
  style,
  isImageMosaic,
  imageMosaicSize = 'lg',
  customMosaicHeight,
  title,
  borderRadius,
  fetchOffset
}) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [numberSlide, setNumberSlide] = useState<number>(0);
  const [slidesToShow, setSlidesToShow] = useState<string[]>(dataGallery?.slice(0, fetchOffset));
  useEffect(() => {
    if (dataGallery?.length) {
      setSlidesToShow(dataGallery?.slice(0, fetchOffset));
    }
  }, [dataGallery?.length]);
  const isMobile = useIsMobile();
  const isImgTextPlural = dataGallery?.length > 1 ? 'Fotos' : 'Foto';
  const onSetImageAndOpenGallery = (index: number) => {
    setNumberSlide(index);
    setOpenGallery(true);
  };
  const onOpenGallery = () => {
    setOpenGallery(true);
    if (isImageMosaic) setNumberSlide(0);
  };
  const handleReachEnd = () => {
    if (slidesToShow?.length !== dataGallery?.length && fetchOffset) {
      const initialIndex = slidesToShow?.length;
      setSlidesToShow(previous => [...previous, ...dataGallery?.slice(initialIndex, initialIndex + fetchOffset)]);
    }
  };
  const handleScroll: React.UIEventHandler<HTMLDivElement> = e => {
    const isAtTheBottom = e.currentTarget?.scrollHeight - e.currentTarget?.scrollTop === e.currentTarget?.clientHeight;
    if (isAtTheBottom) {
      handleReachEnd();
    }
  };
  return <>
      {dataGallery && openGallery && (isMobile ? <ModalOTA padding="0" show={openGallery} mobileVariant="full" closeButtonColor="white" backgroundColor="black" setShow={setOpenGallery} title={title} zIndex={2147483648} stickyHeader onScroll={handleScroll} render={() => <S.MobileModalContents>
                <ImageViewer gallery={slidesToShow} />
              </S.MobileModalContents>} /> : <Gallery initialSlide={numberSlide} dataGallery={slidesToShow} onClose={() => setOpenGallery(false)} onReachEnd={handleReachEnd} />)}
      <S.Card data-testid="image-gallery">
        {isImageMosaic ? <ImageMosaic images={dataGallery} size={imageMosaicSize} customHeight={customMosaicHeight} onClick={onSetImageAndOpenGallery} /> : (/** não remover a classe image-gallery-container pois é utilizada para estilizar em outros componentes */
      <S.BigImageContainer className="image-gallery-container">
            <SlideShow style={style} contents={slidesToShow?.slice(0, fetchOffset)?.map((img, key) => <S.Image key={key} src={img} />)} recommendedBadge={recommendedBadge} recommendedText={recommendedText} borderRadius={borderRadius} onClick={onOpenGallery} />
          </S.BigImageContainer>)}
        {showGalleryBar && <S.Bar barNone={barNone}>
            <S.Swiper onSwiper={setThumbsSwiper} freeMode spaceBetween={10} onClick={() => setOpenGallery(true)} watchSlidesProgress slidesPerView="auto">
              {slidesToShow?.slice(0, fetchOffset)?.map((bullet, idx) => <SwiperSlide key={idx} onClick={() => setNumberSlide(idx)}>
                  <S.Thumb src={bullet} alt="image" />
                </SwiperSlide>)}
            </S.Swiper>
          </S.Bar>}
        {dataGallery && <S.ButtonGallery onClick={onOpenGallery} showButtons={showButtons} isMosaic={isImageMosaic}>
            <img src={IcGallery} alt="" />

            <p>
              <span>{dataGallery?.length}</span>
              {isImageMosaic && <span> {isImgTextPlural}</span>}
            </p>
          </S.ButtonGallery>}
      </S.Card>
    </>;
};
export default ImageGallery;